import React, { useState } from 'react';
import { portalIssueReceipt } from '../api';

export default function IssueReceipt() {
  const user = JSON.parse(localStorage.getItem('portal_user') || '{}');
  const lockerList = (user.locker_codes || '').split(',').map((c: string) => c.trim()).filter(Boolean);

  const [form, setForm] = useState({
    locker_code: lockerList[0] || '',
    gross_amount: '',
    payment_code: 7,
    service_name: 'Luggage Storage',
    transaction_ref: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState<any>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      const r = await portalIssueReceipt({
        locker_code:     form.locker_code,
        gross_amount:    parseFloat(form.gross_amount),
        payment_code:    form.payment_code,
        service_name:    form.service_name,
        transaction_ref: form.transaction_ref || null,
      });
      setResult(r.data);
    } catch (err: any) {
      setError(err.response?.data?.detail?.message || 'Failed to issue receipt');
    } finally { setSaving(false); }
  };

  const inputStyle = { width: '100%', padding: '8px 12px', borderRadius: 6, border: '0.5px solid #ccc', fontSize: 13, boxSizing: 'border-box' as any };
  const labelStyle = { fontSize: 12, color: '#666', display: 'block', marginBottom: 4 };

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Issue Receipt</h2>
      <p style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>Manually issue a fiscal receipt for your locker.</p>

      <div style={{ background: 'white', border: '0.5px solid #e0e0e0', borderRadius: 8, padding: 24, maxWidth: 500 }}>
        {result ? (
          <div>
            <div style={{ background: '#E1F5EE', borderRadius: 8, padding: 20, marginBottom: 20 }}>
              <p style={{ color: '#1D9E75', fontWeight: 600, fontSize: 15, marginBottom: 12 }}>✓ Receipt issued successfully</p>
              <p style={{ fontSize: 13, color: '#444', marginBottom: 4 }}>Mark: <strong>{result.mark}</strong></p>
              <p style={{ fontSize: 13, color: '#444', marginBottom: 12 }}>Issued at: {result.issued_at}</p>
              <a href={result.receipt_url} target="_blank" rel="noreferrer"
                style={{ color: '#185FA5', fontSize: 13, wordBreak: 'break-all' }}>
                {result.receipt_url}
              </a>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => { setResult(null); setForm(f => ({ ...f, gross_amount: '', transaction_ref: '' })); }}
                style={{ padding: '8px 16px', border: '0.5px solid #ccc', borderRadius: 6, fontSize: 13, cursor: 'pointer', background: 'white' }}>
                Issue another
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              {lockerList.length > 1 && (
                <div>
                  <label style={labelStyle}>Locker</label>
                  <select value={form.locker_code} onChange={e => setForm(f => ({ ...f, locker_code: e.target.value }))} style={inputStyle}>
                    {lockerList.map((c: string) => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
              )}
              <div>
                <label style={labelStyle}>Gross amount (€)</label>
                <input type="number" step="0.01" min="0.01" required
                  value={form.gross_amount}
                  onChange={e => setForm(f => ({ ...f, gross_amount: e.target.value }))}
                  style={inputStyle} placeholder="0.00" />
              </div>
              <div>
                <label style={labelStyle}>Payment method</label>
                <select value={form.payment_code} onChange={e => setForm(f => ({ ...f, payment_code: parseInt(e.target.value) }))} style={inputStyle}>
                  <option value={7}>7 — Card</option>
                  <option value={3}>3 — Cash</option>
                </select>
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Service description</label>
              <span style={{ fontSize: 11, color: '#aaa', display: 'block', marginBottom: 4 }}>Appears on the official receipt sent to AADE</span>
              <input value={form.service_name} onChange={e => setForm(f => ({ ...f, service_name: e.target.value }))} style={inputStyle} required />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Internal notes (optional)</label>
              <span style={{ fontSize: 11, color: '#aaa', display: 'block', marginBottom: 4 }}>For your records only — not visible on the receipt</span>
              <input value={form.transaction_ref} onChange={e => setForm(f => ({ ...f, transaction_ref: e.target.value }))} style={inputStyle} placeholder="e.g. customer name..." />
            </div>
            {error && <p style={{ color: '#E24B4A', fontSize: 13, marginBottom: 16 }}>{error}</p>}
            <button type="submit" disabled={saving}
              style={{ padding: '10px 24px', background: '#1D9E75', color: 'white', border: 'none', borderRadius: 6, fontSize: 14, cursor: 'pointer', fontWeight: 500 }}>
              {saving ? 'Issuing...' : 'Issue Receipt'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
